module.exports = __webpack_public_path__ + "media/images/flags/32/Burkina-Faso-279a0beb4fe56b2fb8b9a9a4a1228991.png";